// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".or-divider[data-v-0cca5d18]{color:#696e75;display:block;font-size:12px;padding:8px 0;text-align:center;width:100%}", ""]);
// Exports
module.exports = exports;
